import React from 'react';

import Lottie from 'lottie-react';
import animationData from '../constants/loader.json';

export const LoadingSpinner: React.FC<{
	text?: string;
	className?: string;
}> = ({ text, className = '' }) => {
	return (
		<div
			role="status"
			className={'flex justify-center items-center ' + className}
		>
            <div className='w-[65px] h-[65px]'>
			    <Lottie animationData={animationData} loop={true} />
            </div>
			<span className="sr-only">Loading...</span>
			{text && <p className="text-white font-semibold">{text}</p>}
		</div>
	);
};
